/**
 * Returs only specific filters for each feature group
 * @param {Array} allFilterGroups
 * @param {string} featureGroupName
 * @returns {Array}
 */
export const getAvailableFilters = (allFilterGroups = [], featureGroupName = "", fabricatorId) => {
  let availableFilters = [];
  switch (featureGroupName) {
    case "Center Island Countertop":
    case "Countertop":
      availableFilters = ["stone color", "collection", "manufacturer", "countertop material", "stone finish", "color group", "price group", "material thickness"];
      break;
    case "Backsplash":
      availableFilters = ["stone color", "collection", "manufacturer", "countertop material", "material", "stone finish", "color group", "price group", "material thickness"];
      break;
    default:
      break;
  }
  if (fabricatorId === 260280) { // De Stefano New
    availableFilters.push("currency")
  }
  return availableFilters.length ? allFilterGroups.filter(filterGroup => {
    return filterGroup && filterGroup.name && availableFilters.includes(filterGroup.name.trim().toLowerCase())
  }) : allFilterGroups
};
